<div *ngIf="__oSystemSetting && __oSystemSetting[0] && __oSystemSetting[0].IsCounterpartySegregatedByTradingEntity" class="row margin0px padding0px grey-container">
  <div class="col-lg-6 col-md-6 col-sm-6 padding0px">
    <div class="dx-field">
      <div class="dx-field-label">Our Entity</div>
      <div class="dx-field-value">
        <dx-select-box class="cl-select-box" #sbEntities id="sbEntities" [dataSource]="__oTradingEntities"
                       displayExpr="TradingEntityName" [(value)]="__oEntity.lTradingEntityId"
                       valueExpr="lTradingEntityId" (onSelectionChanged)="onSelectionChanged($event,'Our entity')"
                       searchExpr="TradingEntityName">
        </dx-select-box>
      </div>
    </div>
  </div>
</div>
<div class="row margin0px padding0px">

  <div [ngClass]="{'Disabled' : __oEntity && !__oEntity.lTradingEntityId && __oSystemSetting &&__oSystemSetting[0] && __oSystemSetting[0].IsCounterpartySegregatedByTradingEntity}" class="col-lg-6 col-md-6 col-sm-6 padding0px">
    <div *ngFor="let item of __oCustomPropertyData; let i = index; let even = even;">

      <div *ngIf="item.DisplayOrder % 2 === 0">


        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='String'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-text-area [height]="item.Height" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission" [maxLength]="item.TextSize" [placeholder]="item.CustomProperty" [(value)]="item.Value" (onChange)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" [readOnly]="item.IsReadOnly"></dx-text-area>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='MultiLineString'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-text-area [height]="item.Height" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission" [maxLength]="item.TextSize" [placeholder]="item.DisplayName" [(value)]="item.Value" (onChange)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" [readOnly]="item.IsReadOnly"></dx-text-area>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='DropDown'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-select-box [dataSource]="item.ItemSource"
                           displayExpr="DisplayMember"
                           valueExpr="DisplayMember"
                           [(value)]="item.Value"
                           (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event, 'DropDown');onValueChanged($event);"
                           [searchEnabled]="true"
                           [readOnly]="item.IsReadOnly"
                           [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">

            </dx-select-box>
          </div>
        </div>



        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='File Chooser'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
            <input #fileInput type="file" [attr.id]="item.lCustomPropertyDataId" class="hidden" (click)="fileInput.value = null" value=""
                   (change)="fileUpload($event,item.lCustomPropertyDataId)" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission" />
            <label [attr.for]="item.lCustomPropertyDataId" class="uploadlabel">Choose file</label>
            <div *ngFor="let FileDetail of item.FileDetail">
              <button (click)="DownLoad(FileDetail.FilePath)" class="btn btn-link" title="{{FileDetail.FileName}}" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">{{FileDetail.FileName}}</button>&nbsp;&nbsp;
              <button type="button" class="btn btn-default btn-sm" (click)="DeleteFile(item.lCustomPropertyDataId,FileDetail.FilePath)" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission" style="border:none;">
                <span class="glyphicon glyphicon-trash" style="padding-bottom:7px;"></span>
              </button>
            </div>
          </div>
        </div>






        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Multi Select Combo Box'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-drop-down-box [(value)]="item.MultiSelectedItems"
                              [dataSource]="item.ItemSource"
                              valueExpr="DisplayMember"
                              displayExpr="DisplayMember"
                              placeholder="Select ..."
                              [showClearButton]="true"
                              style="background-color:lightgray"
                              (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event, 'multiselect')"
                              [readOnly]="item.IsReadOnly"
                              [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
              <!--(onFocusIn)="add($event)"-->
              <div *dxTemplate="let contentData of 'content'">
                <dx-list [dataSource]="item.ItemSource"
                         selectionMode="all"
                         itemTemplate="listItem"
                         [height]="400"
                         [selectAllMode]="true"
                         [allowSearch]="true"
                         [showSelectionControls]="true"
                         keyExpr="DisplayMember"
                         [(selectedItemKeys)]="item.MultiSelectedItems"
                         [readOnly]="item.IsReadOnly">

                  <div *dxTemplate="let item of 'listItem'">
                    <b>{{item.DisplayMember}}</b><br />
                  </div>
                </dx-list>
              </div>
            </dx-drop-down-box>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Auto Complete Box Sql'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-autocomplete [placeholder]="item.DisplayName"
                             [dataSource]="item.ItemSource"
                             valueExpr="DisplayMember"
                             [showClearButton]="true"
                             [searchTimeout]="500"
                             [(value)]="item.Value"
                             (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event, 'autocomplete', item);GetDataForACB(item.lCustomPropertyDataId,item.lCustomPropertyId)"
                             [maxItemCount]="30"
                             [(opened)]="item.opened"
                             [readOnly]="item.IsReadOnly"
                             [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
              <!--[(opened)]="opened"-->
            </dx-autocomplete>
          </div>
        </div>





        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Date'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <app-date-picker type="date" [value]="item.Value" [placeholder]="__sPortalDateFormat" [displayFormat]="__sPortalDateFormat"
                             (onDatePickerValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event,'', item)" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
            </app-date-picker>
          </div>
        </div>



        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Numeric' || item.CustomPropertyDataType =='Money'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-number-box [format]="item.FormatString" [ngClass]="{'negativeFontColor' : item.Value != null && item.Value != undefined && item.Value < 0 }" [min]="item.Min" [max]="item.Max" [(value)]="item.Value" (onKeyUp)="onKeyPressNumberBoxState($event,item.lCustomPropertyDataId)" (onChange)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" style="text-align:right;" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"></dx-number-box>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='True/False'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-check-box [(value)]="item.Value" (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
            </dx-check-box>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Uri'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <table style="width:100%;">
              <tr>
                <td style="width:80%">
                  <dx-text-box [height]="30" [visible]="item.ReferenceDataTextBoxVisible" [placeholder]="item.CustomProperty" [(value)]="item.Value"
                               (onFocusOut)="ReferenceTextBoxLostFocus(item.lCustomPropertyDataId)" (onChange)="ReferenceTextBoxLostFocus(item.lCustomPropertyDataId)" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"></dx-text-box>
                  <button (click)="OpenReferenceDataURL(item.lCustomPropertyDataId)" [ngStyle]="{'visibility':item.ReferenceDataURLVisible ? 'visible':'hidden'}"
                          class="btn btn-link" title="{{item.Value}}" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
                    {{item.Value}}
                  </button>
                </td>
                <td style="vertical-align:top;">
                  <dx-button text="Copy" hint="Copy" (onClick)="copyMessage(item.Value)" class="btn-secondary btn_copy" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"></dx-button>
                </td>
                <td style="vertical-align:top;">
                  <dx-button text="Edit" hint="Edit" (onClick)="EditReferenceData(item.lCustomPropertyDataId)" class="btn-secondary btn_edit" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"></dx-button>
                </td>
              </tr>
            </table>
          </div>
        </div>

      </div>
    </div>



  </div>
  <div [ngClass]="{'Disabled' : __oEntity && !__oEntity.lTradingEntityId && __oSystemSetting &&__oSystemSetting[0] && __oSystemSetting[0].IsCounterpartySegregatedByTradingEntity}" class="col-lg-6 col-md-6 col-sm-6">
    <div *ngFor="let item of __oCustomPropertyData; let i = index; let odd = odd;">

      <div *ngIf="item.DisplayOrder % 2 > 0">


        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='String'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-text-area [height]="item.Height" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission" [maxLength]="item.TextSize" [placeholder]="item.CustomProperty" [(value)]="item.Value" (onChange)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" [readOnly]="item.IsReadOnly"></dx-text-area>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='MultiLineString'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-text-area [height]="item.Height" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission" [maxLength]="item.TextSize" [placeholder]="item.DisplayName" [(value)]="item.Value" (onChange)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" [readOnly]="item.IsReadOnly"></dx-text-area>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='DropDown'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-select-box [dataSource]="item.ItemSource"
                           displayExpr="DisplayMember"
                           valueExpr="DisplayMember"
                           [(value)]="item.Value"
                           [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"
                           (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event, 'DropDown');onValueChanged($event);"
                           [searchEnabled]="true"
                           [readOnly]="item.IsReadOnly">
            </dx-select-box>
          </div>
        </div>



        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='File Chooser'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
            <input #fileInput type="file" [attr.id]="item.lCustomPropertyDataId" class="hidden" (click)="fileInput.value = null" value=""
                   (change)="fileUpload($event, item.lCustomPropertyDataId);" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission" />
            <label [attr.for]="item.lCustomPropertyDataId" class="uploadlabel">Choose file</label>
            <div *ngFor="let FileDetail of item.FileDetail">
              <button (click)="DownLoad(FileDetail.FilePath)" class="btn btn-link" title="{{FileDetail.FileName}}" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">{{FileDetail.FileName}}</button>&nbsp;&nbsp;
              <button type="button" class="btn btn-default btn-sm" (click)="DeleteFile(item.lCustomPropertyDataId,FileDetail.FilePath)" style="border:none;" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
                <span class="glyphicon glyphicon-trash" style="padding-bottom:7px;"></span>
              </button>
            </div>
          </div>
        </div>






        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Multi Select Combo Box'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-drop-down-box [(value)]="item.MultiSelectedItems"
                              [dataSource]="item.ItemSource"
                              valueExpr="DisplayMember"
                              displayExpr="DisplayMember"
                              placeholder="Select ..."
                              [showClearButton]="true"
                              style="background-color:lightgray"
                              [allowSearch]="true"
                              (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event, 'multiselect')"
                              [readOnly]="item.IsReadOnly"
                              [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
              <!--(onFocusIn)="add($event)"-->
              <div *dxTemplate="let contentData of 'content'">
                <dx-list [dataSource]="item.ItemSource"
                         selectionMode="all"
                         itemTemplate="listItem"
                         [height]="400"
                         [selectAllMode]="true"
                         [showSelectionControls]="true"
                         keyExpr="DisplayMember"
                         [(selectedItemKeys)]="item.MultiSelectedItems"
                         [readOnly]="item.IsReadOnly">

                  <div *dxTemplate="let item of 'listItem'">
                    <b>{{item.DisplayMember}}</b><br />
                  </div>
                </dx-list>
              </div>
            </dx-drop-down-box>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Auto Complete Box Sql'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-autocomplete [placeholder]="item.DisplayName"
                             [dataSource]="item.ItemSource"
                             valueExpr="DisplayMember"
                             [showClearButton]="true"
                             [searchTimeout]="500"
                             [(value)]="item.Value"
                             (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event, 'autocomplete', item);GetDataForACB(item.lCustomPropertyDataId,item.lCustomPropertyId)"
                             [maxItemCount]="30"
                             [(opened)]="item.opened"
                             [readOnly]="item.IsReadOnly"
                             [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
              <!--[(opened)]="opened"-->
            </dx-autocomplete>
          </div>
        </div>





        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Date'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <app-date-picker type="date" [value]="item.Value" placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy" [displayFormat]="__sPortalDateFormat"
                             (onDatePickerValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event,'', item)" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
            </app-date-picker>
          </div>
        </div>



        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Numeric' || item.CustomPropertyDataType =='Money'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-number-box [format]="item.FormatString" [ngClass]="{'negativeFontColor' : item.Value != null && item.Value != undefined && item.Value < 0 }" [min]="item.Min" [max]="item.Max" [(value)]="item.Value" (onKeyUp)="onKeyPressNumberBoxState($event,item.lCustomPropertyDataId)" (onChange)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" style="text-align:right;" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"></dx-number-box>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='True/False'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <dx-check-box [(value)]="item.Value" (onValueChanged)="TextAreaOnChange(item.lCustomPropertyDataId, $event)" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
            </dx-check-box>
          </div>
        </div>

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='Uri'">
          <div class="dx-field-label" title="{{item.CustomProperty}}">{{item.CustomProperty}}</div>
          <div class="dx-field-value">
            <table style="width:100%;">
              <tr>
                <td style="width:80%">
                  <dx-text-box [height]="30" [visible]="item.ReferenceDataTextBoxVisible" [placeholder]="item.CustomProperty" [(value)]="item.Value"
                               (onFocusOut)="ReferenceTextBoxLostFocus(item.lCustomPropertyDataId)" (onChange)="ReferenceTextBoxLostFocus(item.lCustomPropertyDataId)" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"></dx-text-box>
                  <button (click)="OpenReferenceDataURL(item.lCustomPropertyDataId)" [ngStyle]="{'visibility':item.ReferenceDataURLVisible ? 'visible':'hidden'}"
                          class="btn btn-link " title="{{item.Value}}" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission">
                    {{item.Value}}
                  </button>
                </td>
                <td style="vertical-align:top;">
                  <dx-button text="Edit" hint="Edit" (onClick)="EditReferenceData(item.lCustomPropertyDataId)"
                             style="width:100%;height:30px;padding:0px !important" [readOnly]="item.IsReadOnly" [disabled]="__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission"></dx-button>
                </td>
              </tr>
            </table>
          </div>
        </div>

      </div>
    </div>



  </div>
  <div [ngClass]="{'Disabled' : (__oEntity && !__oEntity.lTradingEntityId && __oSystemSetting &&__oSystemSetting[0] && __oSystemSetting[0].IsCounterpartySegregatedByTradingEntity) || (__oSystemSetting &&__oSystemSetting[0] && __oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && !__oEntity.ourEntityPermission)}" class="col-lg-12 col-md-12 col-sm-12 padding-left-0 padding-left-0">
    <div *ngFor="let item of __oCustomPropertyData; let i = index; let even = even;">

      <div *ngIf="item.CustomPropertyDataType == 'RichTextBox'">

        <div class="dx-field" *ngIf="item.CustomPropertyDataType =='RichTextBox'">
          <div class="dx-field-label rich-text-box-label" title="{{item.CustomProperty}}" style="width: 17.6%; ">
            {{item.CustomProperty}}
          </div>
          <div class="dx-field-value" style="width: 80%; ">
            <div [froalaEditor]="__oFroalaEditorOptions" [(froalaModel)]="item.Value" (froalaModelChange)="onEditorChange(item)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dx-load-panel id="pnlLoad"
                 shadingColor="rgba(0,0,0,0.4)"
                 [position]="{ at: 'center' }"
                 [(visible)]="__bIsLoadingVisible"
                 [showIndicator]="true"
                 [showPane]="true"
                 [shading]="true"
                 [hideOnOutsideClick]="false"
                 [height]="75"
                 [width]="150"
                 message="Please Wait...">
  </dx-load-panel>

</div>

<app-confirmation [__iPopupHeight]="'auto'"></app-confirmation>